import { createApiCall } from 'lib/base';

// "id" maps to the ICB code string (e.g. "8355") in the URL param
const makeDetailCall = (key: string, path: string) =>
  createApiCall(key, ({ id }: { id: string }) => ({
    endpoint: `api/admin/${path}/${id}`,
    method: 'GET',
  }));

export const detailIndustry = makeDetailCall(
  'FETCH_ICB_INDUSTRY_DETAIL',
  'stock-icb/industries'
);
export const detailSuperSector = makeDetailCall(
  'FETCH_ICB_SUPERSECTOR_DETAIL',
  'stock-icb/supersectors'
);
export const detailSector = makeDetailCall(
  'FETCH_ICB_SECTOR_DETAIL',
  'stock-icb/sectors'
);
export const detailSubSector = makeDetailCall(
  'FETCH_ICB_SUBSECTOR_DETAIL',
  'stock-icb/subsectors'
);
